import { IBreadcrumbLink } from 'shared-components';
import { StudentState } from '../../../store/student/types';
import { Link } from 'react-router-dom';
import { IRecordedInterviewEntry, IRecordedInterviewQuestion } from 'api-paths-cas';
import { decrypt } from '../../../utilities/crypto';
import { isString } from 'lodash';

export const getBreadcrumbLinkItems = (student: StudentState): IBreadcrumbLink[] => {
  return [
    { label: 'Students', path: `${window.location.origin}/` },
    {
      label: `${student.personalInfo.givenName} ${student.personalInfo.surname} (${student.core.student_number})`,
      to: `/student/${student.core.university}/${student.core.student_id.split('#')[1]}/${student.offer.intakeId}/${
        student.offer.offerId
      }/`,
      component: Link,
    },
  ];
};

export const getInterview = (
  student: StudentState,
  interviewHash: string,
): IRecordedInterviewEntry | null | undefined => {
  // @ts-expect-error - recordedInterviews is not in IOffer type but exists at runtime
  const { recordedInterviews } = student.offer;

  if (!recordedInterviews) return null;

  return Object.entries(recordedInterviews)
    .map(item => {
      const [interviewHash, interview] = item;
      return {
        ...(interview as IRecordedInterviewEntry),
        interviewHash,
      };
    })
    .find(interview => interview.interviewHash === interviewHash);
};

export const getDecryptedQuestions = (encryptedQuestions: string): IRecordedInterviewQuestion[] => {
  if (!encryptedQuestions || !isString(encryptedQuestions)) {
    return [];
  }
  const decryptedQuestions = decrypt(encryptedQuestions as string);
  return decryptedQuestions ? JSON.parse(decryptedQuestions) : [];
};
